import iFrameResize from 'iframe-resizer/js/iframeResizer';

export default {
  name: 'iframe-resizer',
  inserted(el) {
    iFrameResize({
      checkOrigin: false,
      warningTimeout: 0,
    }, `#${el.id}`);
  },
};
